import { useBondsBondFieldApi } from '../api';

export const useBondsBondCCurrencyCode = () => {
  const response = useBondsBondFieldApi('C_CURRENCY.CODE');
  return response;
};
